module.exports = __webpack_public_path__ + "media/brands/daihatsu-8dafc995.png";